import { ColumnDef } from "@tanstack/react-table";

type AnyColumn<TData> = ColumnDef<TData, any>;

export function buildElColumns<TData>(
  targetColumns: AnyColumn<TData>[],
  transitionColumns: AnyColumn<TData>[] = [],
  actionsColumn?: AnyColumn<TData>,
): AnyColumn<TData>[] {
  return [
    ...targetColumns,
    ...transitionColumns,
    ...(actionsColumn ? [actionsColumn] : []),
  ];
}
